import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseDropdownComponent }                from '../../baseclasses/BaseDropdown.component';

@Component({
  selector: 'my-cooler-style-dropdown',
  templateUrl: './CoolerStyleDropdown.component.html',
  providers: [{provide: BaseDropdownComponent, useExisting: forwardRef(() => CoolerStyleDropdownComponent)}]
})
export class CoolerStyleDropdownComponent extends BaseDropdownComponent {

   
    constructor(private domainDataService: serv.DomainDataService) 
    {
        super();
    }


    ngOnInit(): void {
    }

    public load(){

        this.domainDataService.getCoolerStyles({}).subscribe(x=> this.onGetRecordsDone(x));
    }

    onGetRecordsDone(items: ent.CoolerStyle[]){
        this.selectItems.push({label:"", value:Constants._NONE});
        items.forEach(y=> this.selectItems.push({label:y.FullName, value:y.ID}));
        if (this.selectedID){
            this.value = this.selectedID;
        }
        
    }

}